import { FormContainerState } from "../interfaces/FormContainerState";

export function formContainerReducer(prevState: FormContainerState, newState: FormContainerState): FormContainerState {
    switch (newState.status){
        case "initial":
            return {...newState, status: "initial"};
        case "loading":
            return {...newState, status: "loading"};
        case "error":
            return {...newState, status: "error"};
        default:
            return prevState;
    }
}